/**
 * @license
 * This source code is and remains the property of UserZoom Technologies Inc (sucursal en España).
 * Dissemination of this information or reproduction of this material is strictly
 * forbidden unless prior written permission is obtained from
 * UserZoom Technologies Inc (sucursal en España) (https://www.userzoom.com).
 */

module.exports = {
  black: '#000000',
  darkGrey: '#222222',
  white: '#ffffff',
  grey900: '#0b1128',
  grey800: '#3a3d5d',
  grey700: '#585a75',
  grey600: '#767a92',
  grey500: '#999cb2',
  grey400: '#babdd0',
  grey300: '#d5d8e6',
  grey200: '#e9ebf7',
  grey100: '#f4f5fb',
  darkBlue900: '#020539',
  darkBlue800: '#030845',
  darkBlue700: '#060c55',
  darkBlue600: '#081166',
  darkBlue500: '#252d6c',
  darkBlue400: '#3845ad',
  darkBlue300: '#6271d6',
  darkBlue200: '#9aa6f1',
  darkBlue100: '#cbd2f8',
  brand900: '#7a0a1f',
  brand800: '#93111f',
  brand700: '#b71b1f',
  brand600: '#ee0612',
  brand500: '#ff5036',
  brand400: '#ff8768',
  brand300: '#ffa986',
  brand200: '#ffccae',
  brand100: '#ffe8d6',
  action900: '#0c1777',
  action800: '#152490',
  action700: '#2136b3',
  action600: '#304ad6',
  action500: '#4363f9',
  action400: '#718cfb',
  action300: '#8ea5fd',
  action200: '#b4c5fe',
  action100: '#e7ecfe',
  action50: '#f7f8ff',
  aqua900: '#07416c',
  aqua800: '#0d5a82',
  aqua700: '#147da2',
  aqua600: '#1da4c1',
  aqua500: '#29cfe1',
  aqua400: '#69deea',
  aqua300: '#98e8f0',
  aqua200: '#ccf4f8',
  aqua100: '#e9fafc',
  green900: '#072f1e',
  green800: '#0c4f32',
  green700: '#085e39',
  green600: '#0d753e',
  green500: '#12873d',
  green400: '#409f63',
  green300: '#7bbc93',
  green200: '#b4d9c1',
  green100: '#daece1',
  red900: '#3d0808',
  red800: '#5f0a0b',
  red700: '#880203',
  red600: '#a20d02',
  red500: '#bd1f04',
  red400: '#ca4c36',
  red300: '#da8172',
  red200: '#e9b7ae',
  red100: '#f4dbd7',
  yellow900: '#250600',
  yellow800: '#6d5305',
  yellow700: '#b77f01',
  yellow600: '#db9e01',
  yellow500: '#ffbf02',
  yellow400: '#ffd043',
  yellow300: '#ffdb71',
  yellow200: '#ffeaad',
  yellow100: '#fff7dd',
};
